export function detectDevice() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android|iphone|ipad|ipod|blackberry|windows phone|opera mini|mobile/i.test(userAgent)) {
        return "mobile";
    }
    return "web";
}